import formatDate from 'legacy/utils/date/formatDate'

import { BidState, type RfpSummary } from '../domain/RfpSummary'

export function getBidState(bidState: BidState) {
  if (bidState === BidState.Open) return 'OPEN TO BID'
  return bidState.toUpperCase()
}

export function getBidStatusTagType(bidState: BidState) {
  switch (bidState) {
    case BidState.Submitted:
      return 'warning'

    case BidState.Results:
      return 'accent'

    case BidState.Open:
      return 'success'

    case BidState.Closed:
      return 'default'
  }
}

export function formatContractDate(contractStart: Date, contractEnd: Date): string {
  const dateFormat = 'MMM, d, yyyy'
  return `${formatDate(contractStart, dateFormat)} → ${formatDate(contractEnd, dateFormat)}`
}

export function formatContractDeadline(contractDeadline: Date): string {
  const dateFormat = 'MMM, d, yyyy @ p'
  return `${formatDate(contractDeadline, dateFormat)}`
}

export function sortHistoryByDeadline(rfpHistory: Array<RfpSummary>) {
  return rfpHistory.sort(
    (h1, h2) => h1.rfpRequestDeadline.getTime() - h2.rfpRequestDeadline.getTime()
  )
}

export function formatRfpHistoryEmptyStateMessage(bidState?: BidState) {
  switch (bidState) {
    case BidState.Open:
      return {
        title: 'There are no RFPs open to bid',
        description: 'Once the shipper invites you to bid, the RFPs will be listed here',
      }

    case BidState.Submitted:
      return {
        title: 'There are no submitted RFPs to see',
        description: 'Submit bids so you can manage them here',
      }

    case BidState.Results:
      return {
        title: 'There are no RFPs results to see',
        description: 'Once you have awarded RFPs, the results will be listed here',
      }

    case BidState.Closed:
      return {
        title: 'There are no closed RFPs to see',
        description: 'Once you have RFPs closed they will be listed here',
      }
    default:
      return {
        title: 'There are no RFPs to see here',
        description: 'Receive invitation from shippers to see your bids here',
      }
  }
}
